import { NotificationState } from "app/containers/Features/containers/Notification/types";
import { REPORT_TIME_TICKETS } from "app/containers/Features/containers/Notification/data";
import { sortOrder } from "app/types";

export const initialState: NotificationState = {
  notifications: [],
  activeTab: "all",
  loading: false,
  filteredNotifications: [],
  isNotificationsLoading: false,
  notificationCount: 0,
  isNotificationCountLoading: false,
  notificationsPagination: {
    page: 1,
    perPage: 10,
    orderBy: "createdAt",
    orderDirection: sortOrder.DESC,
    total: 0,
    totalPage: 1,
  },
  reportTimeTickets: REPORT_TIME_TICKETS,
  ticketsPagination: {
    page: 1,
    perPage: 10,
    orderBy: "id",
    orderDirection: sortOrder.ASC,
    total: REPORT_TIME_TICKETS.length,
    totalPage: 1,
  },
  reportTimeSearchTerm: "",
  reportTimeShowDropdown: false,
  reportTimeSelectedTicketIds: [],
  reportTimeTimes: {},
  sprintRetrospectiveStrongPoint: "",
  sprintRetrospectiveFailedPoint: "",
  dayOffType: "",
  dayOffComment: "",
  isMuted: false,
  muteDuration: null,
};
